import { render, staticRenderFns } from "./EmptyTip.vue?vue&type=template&id=439466b8&scoped=true&"
import script from "./EmptyTip.vue?vue&type=script&lang=js&"
export * from "./EmptyTip.vue?vue&type=script&lang=js&"
import style0 from "./EmptyTip.vue?vue&type=style&index=0&id=439466b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439466b8",
  null
  
)

export default component.exports